<template>
    <div class="page-table tabStyle scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.kategori.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.urun.kategori.tanimlama.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.kategori.tanimlama.baslikH1")}}
        </div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunKategoriForm" :rules="rulesUrunKategori" ref="urunKategoriForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             href="http://artdoor.com.tr/">
                                                        http://www.artdoor.com.tr/tr/{{this.urunKategoriForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">http://www.artdoor.com.tr/tr/ </span>
                                                <el-input v-if="VisibleA" v-model="urunKategoriForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="urunKategoriForm.baslik"
                                                    v-on:change="linkTespit"
                                                    v-on:input="linkTespit"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-model="urunKategoriForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Opsiyon Ayarları" name="5">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item prop="kategoriList">
                                                <el-transfer
                                                        style="text-align: left; display: inline-block"
                                                        v-model="urunKategoriForm.opsiyon"
                                                        filterable
                                                        :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                                        :format="{
                                                            noChecked: '${total}',
                                                            hasChecked: '${checked}/${total}'
                                                        }"
                                                        @change="opsiyonChange"
                                                        :data="opsiyonListesi">
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                          prop="seoBaslik">:
                                                <el-input
                                                        v-model="urunKategoriForm.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                          prop="seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="urunKategoriForm.dil.en.baslik"
                                                    v-on:change="urunKategoriForm.dil.en.seoBaslik = urunKategoriForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                      prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-model="urunKategoriForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit"
                                                      @blur="seoIcerikDilTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Opsiyon Ayarları" name="5">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item prop="kategoriList">
                                                <el-transfer
                                                        style="text-align: left; display: inline-block"
                                                        v-model="urunKategoriForm.opsiyon"
                                                        filterable
                                                        :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                                        :format="{
                                                            noChecked: '${total}',
                                                            hasChecked: '${checked}/${total}'
                                                        }"
                                                        @change="opsiyonChange"
                                                        :data="opsiyonListesi">
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                          prop="dil.en.seoBaslik">:
                                                <el-input
                                                        v-model="urunKategoriForm.dil.en.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                          prop="dil.en.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.baslik")'
                                                      prop="dil.de.baslik">:
                                            <el-input
                                                    v-model="urunKategoriForm.dil.de.baslik"
                                                    v-on:change="urunKategoriForm.dil.de.seoBaslik = urunKategoriForm.dil.de.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.altBaslik")'
                                                      prop="dil.de.altBaslik">:
                                            <el-input
                                                    v-model="urunKategoriForm.dil.de.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.de.icerik")'
                                                      prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.dil.de.icerik"
                                                      @input="seoIcerikDil2Tespit"
                                                      @blur="seoIcerikDil2Tespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="Opsiyon Ayarları" name="5">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item prop="kategoriList">
                                                <el-transfer
                                                        style="text-align: left; display: inline-block"
                                                        v-model="urunKategoriForm.opsiyon"
                                                        filterable
                                                        :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                                        :format="{
                                                            noChecked: '${total}',
                                                            hasChecked: '${checked}/${total}'
                                                        }"
                                                        @change="opsiyonChange"
                                                        :data="opsiyonListesi">
                                                </el-transfer>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                          prop="dil.de.seoBaslik">:
                                                <el-input
                                                        v-model="urunKategoriForm.dil.de.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                          prop="dil.de.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.dil.de.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.urun.kategori.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="urunKategoriForm.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini"
                                        v-on:click="urunKategoriTanimlama('urunKategoriForm',urunKategoriForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="urunKategoriForm.durum === '1'">{{$t('src.views.apps.urun.kategori.tanimlama.urunKategoriEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.urun.kategori.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('urunKategoriForm')">
                                            {{$t('src.views.apps.urun.kategori.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.urun.kategori.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.urun.kategori.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.urun.kategori.tanimlama.copKutusu')"
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="urunKategoriTanimlama('urunKategoriForm','0')"
                                               type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.kategori.tanimlama.ustKategori")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="ustKategori">
                                        <el-input v-model="urunKategoriForm.ustKategori"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.urun.kategori.tanimlama.icon")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="icon">
                                        <el-input v-model="urunKategoriForm.icon"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import CKEditor from '@ckeditor/ckeditor5-vue';
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/tr';

    Vue.use(CKEditor)
    import urunService from '../../../../WSProvider/UrunService'
    import status from '../../../../status'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "KategoriTanimlama",
        components: {
            ckeditor: CKEditor.component
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            }else{
                this.getOpsiyonListesi();
            }
        },
        data() {
            return {
                imageListServer: [],
                fileListServer: [],
                opsiyonListesi: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikIngChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5'],
                visibleSil: false,
                checked: true,

                urunKategoriForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    ustKategori: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    resim: [],
                    opsiyonList: [],
                    durum: "1",
                    icon: '',
                    dil: {
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        }
                    }
                },
                rulesUrunKategori: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    musteri: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            linkTespitLink() {
                let self = this;
                if (this.urunKategoriForm.link) {
                    urunService.linkKontrol(self.urunKategoriForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunKategoriForm.link = response.data;
                        } else {
                            status.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    urunService.linkKontrol(self.urunKategoriForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunKategoriForm.baslik) {
                                self.urunKategoriForm.seoBaslik = self.urunKategoriForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunKategoriForm.link = response.data;
                                }
                            } else if (!self.urunKategoriForm.baslik) {
                                self.linkVisible = false;
                                self.urunKategoriForm.link = '';
                                self.urunKategoriForm.seoBaslik = '';
                            }
                        } else {
                            status.Status(response.status, this)
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = strip_html_tags(this.urunKategoriForm.icerik);
                    this.urunKategoriForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunKategoriForm.dil.en.icerik);
                    this.urunKategoriForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDil2Tespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunKategoriForm.dil.de.icerik);
                    this.urunKategoriForm.dil.de.seoIcerik = myStr.substring(0, 140);
                }
            },
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.urunKategoriForm[form] = splitStr.join(' ');
            // },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                status.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                urunService.sunucuResimKategori().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-")+1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    status.Status('success', this, file.name.slice(file.name.indexOf("-")+1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-")+1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-")+1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        status.Status('success', this, file.name.slice(file.name.indexOf("-")+1) + ' resmi eklendi.');
                    } else {
                        status.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        urunService.resimYukleKategori(imgname, data).then((response) => {
                            if (response.status === 200) {
                                var item = {
                                    name: response.data[2].file,
                                    url: urunService.imageUrlKucuk + response.data[2].file
                                }
                            } else {
                                status.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urunKategoriForm.baslik) {
                        var imgname = randomText(13) + '-' + this.urunKategoriForm.link + ".png";
                    } else {
                        imgname = randomText(13) + '-' +linkTemizle(file.name.split('.')[0])+".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                        } else {
                            status.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            getOpsiyonListesi(){
                let self = this;
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            self.opsiyonListesi.push({
                                key: e.uOpsiyonKodu,
                                label: e.baslik,
                            });
                        })
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
            opsiyonChange(value) {
                this.urunKategoriForm.opsiyonList = value;
            },
            urunKategoriTanimlama(formName) {
                let self = this;
                this.urunKategoriForm.resim = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.urunKategoriForm.resim.push(e.name);
                        });
                        let dil = {
                            en: {
                                baslik: this.urunKategoriForm.dil.en.baslik,
                                altBaslik: this.urunKategoriForm.dil.en.altBaslik,
                                icerik: this.urunKategoriForm.dil.en.icerik,
                                seoBaslik: this.urunKategoriForm.dil.en.seoBaslik,
                                seoIcerik: this.urunKategoriForm.dil.en.seoIcerik
                            },
                            de: {
                                baslik: this.urunKategoriForm.dil.de.baslik,
                                altBaslik: this.urunKategoriForm.dil.de.altBaslik,
                                icerik: this.urunKategoriForm.dil.de.icerik,
                                seoBaslik: this.urunKategoriForm.dil.de.seoBaslik,
                                seoIcerik: this.urunKategoriForm.dil.de.seoIcerik
                            }
                        };
                        urunService.urunKategoriTanimlama(this.urunKategoriForm.ustKategori, this.urunKategoriForm.link, this.urunKategoriForm.baslik,
                            this.urunKategoriForm.altBaslik, this.urunKategoriForm.icerik, this.urunKategoriForm.resim,
                            this.urunKategoriForm.seoBaslik, this.urunKategoriForm.seoIcerik, this.urunKategoriForm.icon, this.urunKategoriForm.durum,
                            dil,this.urunKategoriForm.opsiyonList).then((response) => {
                            if (response.status === 200) {
                                status.Status('success', this, 'Kategori başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                                $('.el-upload-list__item-delete').click();
                            } else if (response.status === 230) {
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                status.Status(response.status, this)
                            }
                        })
                    }
                })
            },
        }
    }
    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }
    function linkTemizle(text)
    {
        var trMap = {
            'çÇ':'c',
            'ğĞ':'g',
            'şŞ':'s',
            'üÜ':'u',
            'ıİ':'i',
            'öÖ':'o'
        };
        for(var key in trMap) {
            text = text.replace(new RegExp('['+key+']','g'), trMap[key]);
        }
        return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }


    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>
<style scoped>
    #affix-container.tabStyle {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }
</style>
<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>